module.exports = __webpack_public_path__ + "static/anestesia-62be99a5827d742658ac176a66ff51fd.jpg";